import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=632346c8&"
import script from "./UserGuide.vue?vue&type=script&lang=js&"
export * from "./UserGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports